import Popover from 'react-simple-popover';
import { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import * as React from 'react';

import SanitizedString from '../../../common/SanitizedString';
import { findDOMNode } from 'react-dom';

class GradesTasksTopIcon extends React.Component {
  static propTypes = {
    task: PropTypes.object.isRequired
  };

  buttonNode = null;

  constructor(props, context) {
    super(props, context);
    this.state = {
      visiblePopover: false
    };
    this.showPopover = this.showPopover.bind(this);
    this.hidePopover = this.hidePopover.bind(this);
    this.getButtonContainer = this.getButtonContainer.bind(this);
    this.setPopoverPosition = this.setPopoverPosition.bind(this);
  }

  showPopover() {
    this.setPopoverPosition();
    this.setState({ visiblePopover: true });
  }

  setPopoverPosition() {
    /* eslint-disable */
    let pos = findDOMNode(this.buttonNode).getBoundingClientRect();
    /* eslint-enable */
    let style = Object.assign({}, this.state.style);
    style.left = pos.left + 3;
    style.top = pos.top + 13;
    style.borderColor = `transparent transparent ${this.props.color}`;
    this.setState({ style });
  }

  hidePopover() {
    this.setState({ visiblePopover: false });
  }

  getButtonContainer() {
    return this.buttonNode;
  }

  render() {
    const { task } = this.props;
    const { visiblePopover } = this.state;

    return (
      <div className="open-popover cursor-default" onMouseLeave={this.hidePopover} onMouseEnter={this.showPopover}>
        <span
          ref={node => {
            this.buttonNode = node;
          }}
          className="custom-icons-blank-paper-sheet icons"
        />
        <div className="popover-wrapper">
          <Popover
            target={this.getButtonContainer()}
            placement="bottom"
            show={visiblePopover}
            style={{
              padding: '0px',
              width: 'fit-content',
              boxShadow: 'none',
              backgroundColor: '#ffffff00'
            }}
          >
            <div>
              <div
                className="arrow"
                style={{
                  position: 'absolute',
                  top: '-5px',
                  left: '50%',
                  marginLeft: '-8px'
                }}
              >
                <div className="blue-icon" style={{}}></div>
                <div className="white-icon" style={{}}></div>
              </div>
              <div className="simple-popover holaaaa">
                <div className={`popover-shape`}>
                  <div className="popover-text">
                    <SanitizedString rawString={task.name} />
                  </div>
                </div>
              </div>
            </div>
          </Popover>
        </div>
      </div>
    );
  }
}

export default GradesTasksTopIcon;
